module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "components-container"
  }, [_c('div', {
    staticClass: "filter-container"
  }, [_c('el-select', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "filterable": "",
      "placeholder": "学年"
    },
    on: {
      "change": _vm.classOption
    },
    model: {
      value: (_vm.queryForm.xnbm),
      callback: function($$v) {
        _vm.$set(_vm.queryForm, "xnbm", $$v)
      },
      expression: "queryForm.xnbm"
    }
  }, _vm._l((_vm.xnInfo), function(item) {
    return _c('el-option', {
      key: item.comboValue,
      attrs: {
        "label": item.comboName,
        "value": item.comboValue
      }
    })
  }), 1), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "width": "18%"
    },
    attrs: {
      "filterable": "",
      "placeholder": "系部名称",
      "multiple": "",
      "clearable": ""
    },
    on: {
      "change": _vm.changeDept
    },
    model: {
      value: (_vm.queryForm.deptCode),
      callback: function($$v) {
        _vm.$set(_vm.queryForm, "deptCode", $$v)
      },
      expression: "queryForm.deptCode"
    }
  }, _vm._l((_vm.deptInfo), function(item) {
    return _c('el-option', {
      key: item.comboValue,
      attrs: {
        "label": item.comboName,
        "value": item.comboValue
      }
    })
  }), 1), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "width": "18%"
    },
    attrs: {
      "filterable": "",
      "placeholder": "专业名称",
      "multiple": "",
      "clearable": ""
    },
    on: {
      "change": _vm.classOption
    },
    model: {
      value: (_vm.queryForm.majorCode),
      callback: function($$v) {
        _vm.$set(_vm.queryForm, "majorCode", $$v)
      },
      expression: "queryForm.majorCode"
    }
  }, _vm._l((_vm.majorInfo), function(item) {
    return _c('el-option', {
      key: item.comboValue,
      attrs: {
        "label": item.comboName,
        "value": item.comboValue
      }
    })
  }), 1), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "width": "18%"
    },
    attrs: {
      "filterable": "",
      "placeholder": "班级名称",
      "multiple": "",
      "clearable": ""
    },
    model: {
      value: (_vm.queryForm.classCode),
      callback: function($$v) {
        _vm.$set(_vm.queryForm, "classCode", $$v)
      },
      expression: "queryForm.classCode"
    }
  }, _vm._l((_vm.classInfo), function(item) {
    return _c('el-option', {
      key: item.comboValue,
      attrs: {
        "label": item.comboName,
        "value": item.comboValue
      }
    })
  }), 1), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "width": "18%"
    },
    attrs: {
      "filterable": "",
      "placeholder": "学籍异动状态",
      "multiple": "",
      "clearable": ""
    },
    model: {
      value: (_vm.queryForm.statusCode),
      callback: function($$v) {
        _vm.$set(_vm.queryForm, "statusCode", $$v)
      },
      expression: "queryForm.statusCode"
    }
  }, _vm._l((_vm.statusInfo), function(item) {
    return _c('el-option', {
      key: item.comboValue,
      attrs: {
        "label": item.comboName,
        "value": item.comboValue
      }
    })
  }), 1), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "type": "gray"
    },
    on: {
      "click": _vm.handleFilter
    }
  }, [_c('i', {
    staticClass: "el-icon-search"
  }), _vm._v(" 查询")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "type": "gray"
    },
    on: {
      "click": _vm.handleReset
    }
  }, [_c('i', {
    staticClass: "el-icon-refresh"
  }), _vm._v(" 重置")])], 1), _vm._v(" "), _c('div', {
    staticClass: "filter-container"
  }, [_c('div', {
    staticClass: "checkItem_label"
  }, [_vm._v("请选择要显示的统计项目：")]), _vm._v(" "), _c('div', {
    staticClass: "checkItem"
  }, [_c('el-checkbox-group', {
    on: {
      "change": _vm.handlecheckedItemsChange
    },
    model: {
      value: (_vm.checkedItems),
      callback: function($$v) {
        _vm.checkedItems = $$v
      },
      expression: "checkedItems"
    }
  }, _vm._l((_vm.itemOption), function(item) {
    return _c('el-checkbox', {
      key: item,
      attrs: {
        "label": item
      }
    }, [_vm._v(_vm._s(item))])
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "height": "20px"
    }
  })]), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading.body",
      value: (_vm.tableLoading),
      expression: "tableLoading",
      modifiers: {
        "body": true
      }
    }],
    ref: "mainTable",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData,
      "show-summary": "",
      "summary-method": _vm.getSummaries,
      "element-loading-text": "信息加载中",
      "highlight-current-row": "",
      "border": "",
      "height": _vm.mainTableHeight
    },
    on: {
      "curplus-outlinerent-change": _vm.handleCurrentChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "序号",
      "width": "80",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s((_vm.currentPage - 1) * _vm.limit + scope.$index + 1))])]
      }
    }])
  }), _vm._v(" "), (_vm.deptShow == true) ? _c('el-table-column', {
    attrs: {
      "label": "系部名称",
      "prop": "deptName",
      "align": "center",
      "min-width": "20%"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.majorShow == true) ? _c('el-table-column', {
    attrs: {
      "label": "专业名称",
      "prop": "majorName",
      "align": "center",
      "min-width": "20%"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.classShow == true) ? _c('el-table-column', {
    attrs: {
      "label": "班级名称",
      "prop": "className",
      "align": "center",
      "min-width": "20%"
    }
  }) : _vm._e(), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "学生人数",
      "prop": "stuNumber",
      "align": "center",
      "min-width": "10%"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "学籍异动人次",
      "prop": "statusNumber",
      "align": "center",
      "min-width": "10%"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "学籍异动详情",
      "align": "center",
      "min-width": "10%"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small",
            "type": "primary"
          },
          on: {
            "click": function($event) {
              return _vm.showInfo(scope.row);
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-tickets"
        }), _vm._v(" 详情\n                ")])]
      }
    }])
  })], 1), _vm._v(" "), (_vm.statusDialogVisiable) ? _c('el-dialog', {
    attrs: {
      "title": _vm.statusTitle,
      "visible": _vm.statusDialogVisiable,
      "width": "36%",
      "top": "180px",
      "append-to-body": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.statusDialogVisiable = $event
      }
    }
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading.body",
      value: (_vm.tableLoading),
      expression: "tableLoading",
      modifiers: {
        "body": true
      }
    }],
    ref: "statusTable",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.statusTableData,
      "show-summary": "",
      "summary-method": _vm.getSummaries,
      "element-loading-text": "信息加载中",
      "highlight-current-row": "",
      "border": "",
      "height": _vm.statusTableHeight
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "序号",
      "width": "80",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s((_vm.currentPage - 1) * _vm.limit + scope.$index + 1))])]
      }
    }], null, false, 2799227377)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "异动类别",
      "prop": "changeName",
      "align": "center",
      "min-width": "20%"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "人次",
      "prop": "statusNumber",
      "align": "center",
      "min-width": "20%"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "height": "20px"
    }
  })], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7e6cd7a7"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/basicReport/tempHighBasicReport.vue
// module id = 1877
// module chunks = 502